import React, { useEffect, useState } from 'react';
import fetch from 'unfetch';
import { feature } from 'topojson-client';

import MapWrapper from './MapWrapper';

const Map = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    (async () => {
      const response = await fetch('data/districts.topo.json');
      const topo = await response.json();
      const topoKey = Object.keys(topo.objects)[0];
      const geo = feature(topo, topo.objects[topoKey]);
      setData(geo);
    })();
  }, []);

  if (!data) {
    return null;
  }

  return <MapWrapper data={data} />
};

export default Map;
